import { useEffect } from 'react';
import AdminLayout from '@/components/layout/AdminLayout';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { StandardPageHeader } from '@/components/layout/StandardPageHeader';
import { PageContainer } from '@/components/layout/PageContainer';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();

  // Redirect after a delay
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/admin/settings/subscription-center');
    }, 10000); // Redirect after 10 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleContinue = () => {
    navigate('/admin/settings/subscription-center');
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <StandardPageHeader
          title="Subscription Successful"
          subtitle="Thank you for subscribing to Hivetivity"
          icon={CheckCircle}
        />
        
        <PageContainer maxWidth="md">
          <div className="flex flex-col items-center justify-center">
            <Card className="w-full max-w-md">
              <CardHeader className="text-center">
                <div className="mx-auto bg-green-100 p-3 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                  <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
                <CardTitle className="text-2xl">Subscription Activated!</CardTitle>
                <CardDescription>Welcome to premium Hivetivity features</CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <p>Your subscription has been activated successfully. You now have access to all the premium features.</p>
              </CardContent>
              <CardFooter className="flex justify-center">
                <Button onClick={handleContinue}>
                  Continue to Subscription Center
                </Button>
              </CardFooter>
            </Card>
          </div>
        </PageContainer>
      </div>
    </AdminLayout>
  );
} 